export default [
    { label: "Name", prop: "name", type: "text", group: "main", inputClass: "diagonal-wrap" },
]
